const TEXT = {
    INVITE_USER_TEXT_1:"扫一扫二维码，马上申请代理 ",
    INVITE_USER_TEXT_2:"复制链接",
    INVITE_USER_TEXT_3:"微信代理授权",
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/invite/inviteuser/index.js